import React from "react";
import { IonButton, IonImg } from "@ionic/react";

export const ManageUserEmpty:React.FC<any> = (props:any) => {
    return (
      <div className="No-Recommended">
        <img
          alt="logo"
          src="assets/icon/no-user.svg"
          width="79.01px"
          height="84.59px"
        />
        {props.message ? (
          <p className="recommended-Error">
            No matches found, please modify your search.
          </p>
        ) : (
          <p className="recommended-Error">
              We don't have any users right now. <br /> Please click on <b>Add</b> to add new user.
          </p>
        )}
        <div className="SearchLoadBtn">
          <IonButton
            expand="full"
            shape="round"
            onClick={props.addPage}
            size="large"
            type="submit"
            class="RecommendedSearch"
          >
            <IonImg src="assets/icon/add.svg" class="load-search" />
            {props.constantButton}
          </IonButton>
        </div>
      </div>
    );
}
